// JsFromRoutes CacheKey b7feea0d770dd44fd6895feeff0736cd
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/axios'

export default {
  list: definePathHelper('get', '/api/years/:year_id/challenge_forms'),
  destroy: definePathHelper('delete', '/api/years/:year_id/challenge_forms/:id'),
  destroyAttachment: definePathHelper('delete', '/api/years/:year_id/championship_teams/:championship_team_id/challenge_forms/:id/supporting_docs/:file_id'),
  getAllParties: definePathHelper('get', '/api/years/:year_id/championship_teams/:championship_team_id/challenge_forms/:id/all_parties'),
  create: definePathHelper('post', '/api/years/:year_id/championship_teams/:championship_team_id/challenge_forms'),
  get: definePathHelper('get', '/api/years/:year_id/championship_teams/:championship_team_id/challenge_forms/:id'),
  update: definePathHelper('patch', '/api/years/:year_id/championship_teams/:championship_team_id/challenge_forms/:id'),
}
